import { render, staticRenderFns } from "./PageMealCategory.vue?vue&type=template&id=fcd10608"
import script from "./PageMealCategory.vue?vue&type=script&lang=js"
export * from "./PageMealCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports